import React, { useState } from 'react';
import { Button, Checkbox, Form, Input, Alert, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { UserOutlined, LockOutlined, LoginOutlined } from '@ant-design/icons';
import { login } from '../../features/auth/authSlice';
import { Link } from 'react-router-dom';

const { Title, Text } = Typography;

const SignIn = () => {
  const dispatch = useDispatch();
  const { error, loading } = useSelector((state) => state.auth);
  const [credentials, setCredentials] = useState({ email: '', password: '' });

  const handleSubmit = (values) => {
    dispatch(login(credentials));
  };

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleFocus = () => {
    if (error) {
      dispatch({ type: 'auth/clearError' });
    }
  };

  return (
    <div className="w-full max-w-md mx-auto">
      {/* Header */}
      <div className="text-center mb-8">
        <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
          <LoginOutlined className="text-2xl text-white" />
        </div>
        <Title level={2} className="mb-2 text-slate-800">Welcome Back</Title>
        <Text className="text-slate-600">Please sign in to your account</Text>
      </div>

      <Form
        onFinish={handleSubmit}
        name="signin"
        layout="vertical"
        autoComplete="on"
        size="large"
        className="space-y-1"
      >
        {error && (
          <Alert 
            className="mb-6" 
            message={error} 
            type="error" 
            showIcon 
            closable 
          />
        )}

        <Form.Item
          label={<span className="text-slate-700 font-medium">Email Address</span>}
          name="email"
          rules={[
            { required: true, message: 'Please input your email!' },
            { type: 'email', message: 'Please enter a valid email!' }
          ]}
        >
          <Input
            name="email"
            prefix={<UserOutlined className="text-slate-400" />}
            placeholder="Enter your email"
            value={credentials.email}
            onChange={handleChange}
            onFocus={handleFocus}
            className="rounded-lg h-12"
          />
        </Form.Item>

        <Form.Item
          label={<span className="text-slate-700 font-medium">Password</span>}
          name="password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password
            name="password"
            prefix={<LockOutlined className="text-slate-400" />}
            placeholder="Enter your password"
            value={credentials.password}
            onChange={handleChange}
            onFocus={handleFocus}
            className="rounded-lg h-12"
          />
        </Form.Item>

        <Form.Item
          name="remember"
          valuePropName="checked"
          className="mb-6"
        >
          <div className="flex items-center justify-between">
            <Checkbox className="text-slate-600">Remember me</Checkbox>
            <Link to="/forgot-password" className="text-blue-500 hover:text-blue-600 text-sm">
              Forgot Password?
            </Link>
          </div>
        </Form.Item>

        <Form.Item className="mb-4">
          <Button
            type="primary"
            loading={loading}
            htmlType="submit"
            icon={<LoginOutlined />}
            className="w-full h-12 bg-blue-600 hover:bg-blue-700 border-blue-600 hover:border-blue-700 rounded-lg font-medium text-base"
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </Button>
        </Form.Item>

        <div className="text-center">
          <Text className="text-slate-600">Don't have an account? </Text>
          <Link to="/register" className="text-blue-500 hover:text-blue-600 font-medium">
            Register Here
          </Link>
        </div>
      </Form>
    </div>
  );
};

export default SignIn;